export const namespaced = true;

export const state = {
    baseTypes: [
        { slug: "plate-fill", title: "Плита заливная", hint: "Подсказка" },
        { slug: "stripe", title: "Полоса", hint: "Подсказка" },
        { slug: "plate-ready", title: "Плита мощения", hint: "Подсказка" },
        { slug: "paving", title: "Мощение", hint: "Подсказка" },
        { slug: "pour", title: "Отсыпка", hint: "Подсказка" },
        { slug: "grass", title: "Газон", hint: "Подсказка" }
    ],
    selectedBaseType: null,

    mainElementTypes: null,
    selectedMainElement: null,

    facingTopTypes: null,
    facingSideTypes: null,
    selectedFacingElement: {
        top: null,
        side: null
    },

    showFillTypes: false,
    fillTypes: [
        { slug: "paving", title: "Мощение", hint: "Подсказка" },
        { slug: "pour", title: "Отсыпка", hint: "Подсказка" },
        { slug: "grass", title: "Газон", hint: "Подсказка" }
    ],
    selectedFillType: null,
    fillElementTypes: null,
    selectedFillElement: null,

    borderElementTypes: null,
    selectedBorderElement: null,
    loadingElements: {}
};

export const mutations = {
    SET_LANDSCAPING(state, selected) {
        state.selectedBaseType = selected.mainElementType;
        state.selectedMainElement = selected.mainElement;
        state.selectedFacingElement = {
            top: selected.facing_top,
            side: selected.facing_side
        };
        state.selectedFillType = selected.fillType;
        state.selectedFillElement = selected.fillElement;
        state.selectedBorderElement = selected.borderElement;
    },
    CLEAR_LANDSCAPING(state, elements) {
        state.selectedBaseType = null;
        state.mainElementTypes = null;
        state.selectedMainElement = null;
        state.facingTopTypes = null;
        state.facingSideTypes = null;
        state.selectedFacingElement = {
            top: null,
            side: null
        };
        state.showFillTypes = false;
        state.selectedFillType = null;
        state.fillElementTypes = null;
        state.selectedFillElement = null;
        state.borderElementTypes = null;
        state.selectedBorderElement = null;
    },

    SELECT_BASE_TYPE(state, selectedBaseType) {
        state.selectedBaseType = selectedBaseType;
    },

    FETCH_MAIN_ELEMENT_TYPES(state, mainElementTypes) {
        const expanded = JSON.parse(localStorage.getItem('expanded_landscaping_mainElementTypes') || '[]');
        mainElementTypes.types.forEach(type => {
            if (expanded.includes(type.type_id)) {
                type.showElements = true;
            }
        });
        state.mainElementTypes = mainElementTypes;
    },

    SELECT_MAIN_ELEMENT(state, selectedMainElement) {
        state.selectedMainElement = selectedMainElement;
    },

    FETCH_FACING_TOP_TYPES(state, facingTopTypes) {
        const expanded = JSON.parse(localStorage.getItem('expanded_landscaping_facingTopTypes') || '[]');
        facingTopTypes.types.forEach(type => {
            if (expanded.includes(type.type_id)) {
                type.showElements = true;
            }
        });
        state.facingTopTypes = facingTopTypes;
    },

    FETCH_FACING_SIDE_TYPES(state, facingSideTypes) {
        const expanded = JSON.parse(localStorage.getItem('expanded_landscaping_facingSideTypes') || '[]');
        facingSideTypes.types.forEach(type => {
            if (expanded.includes(type.type_id)) {
                type.showElements = true;
            }
        });
        state.facingSideTypes = facingSideTypes;
    },

    SELECT_FACING_ELEMENT(state, { selectedFacingElement, facing }) {
        state.selectedFacingElement[facing] = selectedFacingElement;
    },

    SELECT_FILL_TYPE(state, selectedFillType) {
        state.selectedFillType = selectedFillType;
    },

    FETCH_FILL_ELEMENT_TYPES(state, fillElementTypes) {
        state.fillElementTypes = fillElementTypes;
    },

    SELECT_FILL_ELEMENT(state, selectedFillElement) {
        state.selectedFillElement = selectedFillElement;
    },

    FETCH_BORDER_ELEMENT_TYPES(state, borderElementTypes) {
        state.borderElementTypes = borderElementTypes;
    },

    SELECT_BORDER_ELEMENT(state, selectedBorderElement) {
        state.selectedBorderElement = selectedBorderElement;
    },

    SET_TYPE_SHOW_ELEMENTS(state, { typePosition, typeId, show }) {
        const typeIndex = state[typePosition].types.findIndex(
            t => t.type_id == typeId
        );
        if (typeIndex >= 0) {
            state[typePosition].types[typeIndex].showElements = show;
            state[typePosition].types = [...state[typePosition].types];

            let expanded = JSON.parse(localStorage.getItem(`expanded_landscaping_${typePosition}`) || '[]');
            if (show) {
                if (!expanded.includes(typeId)) expanded.push(typeId);
            } else {
                expanded = expanded.filter(id => id !== typeId);
            }
            localStorage.setItem(`expanded_landscaping_${typePosition}`, JSON.stringify(expanded));
        }
    },

    SET_TYPE_ELEMENTS(state, { typePosition, typeId, elements }) {
        const typeIndex = state[typePosition].types.findIndex(
            t => t.type_id == typeId
        );
        if (typeIndex >= 0) {
            if (state[typePosition].types[typeIndex].elements.length) {
                elements.forEach(element => {
                    state[typePosition].types[typeIndex].elements.push(element);
                });
            } else {
                state[typePosition].types[typeIndex].elements = elements;
            }

            state[typePosition].types = [...state[typePosition].types];
        }
    },

    CLEAR_TYPE_ELEMENTS(state, { typePosition, typeId }) {
        const typeIndex = state[typePosition].types.findIndex(
            t => t.type_id == typeId
        );
        if (typeIndex >= 0) {
            state[typePosition].types[typeIndex].elements = [];
            state[typePosition].types = [...state[typePosition].types];
        }
    },

    SET_TYPE_META(state, { typePosition, typeId, meta }) {
        const typeIndex = state[typePosition].types.findIndex(
            t => t.type_id == typeId
        );
        if (typeIndex >= 0) {
            state[typePosition].types[typeIndex].meta = meta;
            state[typePosition].types = [...state[typePosition].types];
        }
    },

    SET_LOADING_ELEMENTS(state, { typeId, loading }) {
        state.loadingElements[typeId] = loading;
    }
};

export const actions = {
    setTypeShowElements({ commit }, { typePosition, typeId, show }) {
        commit("SET_TYPE_SHOW_ELEMENTS", { typePosition, typeId, show });
    },

    clearTypeElements({ commit }, { typePosition, typeId }) {
        commit("CLEAR_TYPE_ELEMENTS", { typePosition, typeId });
        commit("SET_TYPE_META", { typePosition, typeId, meta: null });
    },

    async getElementsByType(
        { commit, dispatch, state, rootState },
        { typePosition, typeId }
    ) {
        commit("SET_LOADING_ELEMENTS", { typeId, loading: true });
        let page = 1;
        const type = state[typePosition].types.find(t => t.type_id == typeId);
        if (type && type.meta && type.meta.current_page) {
            page = type.meta.current_page + 1;
        }
        try {
            const res = (
                await axios.get(`/api/type-elements/${typeId}`, {
                    params: {
                        per_page:
                            parseInt(
                                rootState.settings.settings
                                    .count_elements_configurator
                            ) || 24,
                        page
                    }
                })
            ).data;
            commit("SET_TYPE_ELEMENTS", {
                typePosition,
                typeId,
                elements: res.data
            });
            commit("SET_TYPE_META", {
                typePosition,
                typeId,
                meta: res?.meta
            });
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        } finally {
            commit("SET_LOADING_ELEMENTS", { typeId, loading: false });
        }
    },

    setLandscaping({ commit }, selected) {
        commit("SET_LANDSCAPING", selected);
    },

    selectBaseType({ commit, dispatch }, selectedBaseType) {
        commit("SELECT_BASE_TYPE", selectedBaseType);
        dispatch("fetchMainElementTypes");
        dispatch("clientOrder/clearLandscaping", {}, { root: true });
        dispatch(
            "clientOrder/addLandscaping",
            { element: selectedBaseType, position: "mainElementType" },
            { root: true }
        );
    },

    async fetchMainElementTypes({ commit, state, dispatch, rootGetters }) {
        try {
            const res = (
                await axios.get(
                    `/api/element_groups/${state.selectedBaseType.slug}`
                )
            ).data;

            commit("FETCH_MAIN_ELEMENT_TYPES", res.data.element_group);
            const selectedLandscaping =
                rootGetters["clientOrder/selectedLandscaping"];

            if (selectedLandscaping && selectedLandscaping.mainElement) {
                dispatch("setTypeShowElements", {
                    typePosition: "mainElementTypes",
                    typeId: selectedLandscaping.mainElement.type_id,
                    show: true
                });
            }
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    selectMainElement({ commit, state, dispatch }, selectedMainElement) {
        commit("SELECT_MAIN_ELEMENT", selectedMainElement);

        if (
            state.selectedBaseType.slug == "plate-fill" ||
            state.selectedBaseType.slug == "stripe"
        ) {
            dispatch("fetchFacingTypes");
        }
        if (
            state.selectedBaseType.slug == "paving" ||
            state.selectedBaseType.slug == "pour" ||
            state.selectedBaseType.slug == "grass"
        ) {
            if (!state.borderElementTypes) {
                dispatch("fetchBorderTypes");
            }

        }
        dispatch(
            "clientOrder/addLandscaping",
            { element: selectedMainElement, position: "mainElement" },
            { root: true }
        );
    },

    async fetchFacingTypes({ commit, dispatch }) {
        try {
            const res = (await axios.get(`/api/element_groups/facing`)).data;

            const { types, element_group_id, name } = res.data.element_group;

            const topTypes = {
                element_group_id,
                name,
                types: []
            };

            const sideTypes = {
                element_group_id,
                name,
                types: []
            };

            types.forEach(type => {
                let elementsTop = [];
                let elementsSide = [];

                type.elements.forEach(el => {
                    if (el.facing == "top") {
                        elementsTop.push(el);
                    }

                    if (el.facing == "side") {
                        elementsSide.push(el);
                    }

                    if (el.facing == "top_side" || !el.facing) {

                        let objTop = Object.assign({}, { ...el });
                        objTop = { ...objTop, element_id: `top-${el.element_id}` };
                        elementsTop.push(objTop);

                        let objSide = Object.assign({}, { ...el });
                        objSide = { ...objSide, element_id: `side-${el.element_id}` };
                        elementsSide.push(objSide);
                    }
                });

                if (elementsTop.length) {
                    topTypes.types.push({
                        type_id: type.type_id,
                        name: type.name,
                        image: type.image,
                        showElements: type.showElements,
                        elements: elementsTop
                    });
                }

                if (elementsSide.length) {
                    sideTypes.types.push({
                        type_id: type.type_id,
                        name: type.name,
                        image: type.image,
                        showElements: type.showElements,
                        elements: elementsSide
                    });
                }
            });

            commit("FETCH_FACING_TOP_TYPES", topTypes);
            commit("FETCH_FACING_SIDE_TYPES", sideTypes);
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    selectFacingElement(
        { commit, dispatch },
        { selectedFacingElement, facing }
    ) {
        commit("SELECT_FACING_ELEMENT", {
            selectedFacingElement,
            facing
        });
        dispatch(
            "clientOrder/addLandscaping",
            {
                element: selectedFacingElement,
                position: `facing_${facing}`
            },
            { root: true }
        );
    },

    selectFillType({ commit, dispatch }, selectedFillType) {
        commit("SELECT_FILL_TYPE", selectedFillType);
        dispatch("fetchFillElementTypes");
        dispatch(
            "clientOrder/addLandscaping",
            { element: selectedFillType, position: "fillType" },
            { root: true }
        );
    },

    async fetchFillElementTypes({ commit, state, dispatch, rootGetters }) {
        try {
            const res = (
                await axios.get(
                    `/api/element_groups/${state.selectedFillType.slug}`
                )
            ).data;
            commit("FETCH_FILL_ELEMENT_TYPES", res.data.element_group);
            const selectedLandscaping =
                rootGetters["clientOrder/selectedLandscaping"];

            if (selectedLandscaping && selectedLandscaping.fillElement) {
                dispatch("setTypeShowElements", {
                    typePosition: "fillElementTypes",
                    typeId: selectedLandscaping.fillElement.type_id,
                    show: true
                });
            }
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    selectFillElement({ commit, dispatch }, selectedFillElement) {
        commit("SELECT_FILL_ELEMENT", selectedFillElement);
        dispatch(
            "clientOrder/addLandscaping",
            { element: selectedFillElement, position: "fillElement" },
            { root: true }
        );
    },

    async fetchBorderTypes({ commit, dispatch, rootGetters }) {
        try {
            const res = (await axios.get(`/api/element_groups/border`)).data;
            commit("FETCH_BORDER_ELEMENT_TYPES", res.data.element_group);
            const selectedLandscaping =
                rootGetters["clientOrder/selectedLandscaping"];

            if (selectedLandscaping && selectedLandscaping.borderElement) {
                dispatch("setTypeShowElements", {
                    typePosition: "borderElementTypes",
                    typeId: selectedLandscaping.borderElement.type_id,
                    show: true
                });
            }
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    selectBorderElement({ commit, dispatch }, selectedBorderElement) {
        commit("SELECT_BORDER_ELEMENT", selectedBorderElement);
        dispatch(
            "clientOrder/addLandscaping",
            {
                element: selectedBorderElement,
                position: "borderElement"
            },
            { root: true }
        );
    }
};
